import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import cn from 'classnames';
import { ArrowsHorizontal, Sync } from '../../icons';
import styles from './IntegrationSyncIcon.module.scss';
const sizeToPx = {
    xsmall: 16,
    small: 20,
    medium: 24,
    large: 64
};
export const IntegrationSyncIcon = (param)=>{
    let { variant = 'sync', status = 'success', size = 'small', testId } = param;
    const px = sizeToPx[size];
    const Glyph = variant === 'mapping' ? ArrowsHorizontal : Sync;
    return(// WHY: the svg only carries width/height attributes, so flex rows could still squash it without min-width.
    /*#__PURE__*/ _jsx(Glyph, {
        size: px,
        style: {
            minWidth: px
        },
        className: cn(styles.icon, styles[status]),
        testId: testId
    }));
};
